import { Button, Text, Layout, useLocalVariant, Flex } from "@draftkings/arena-web";
import * as React from "react";
export const Notification = React.memo(function Notification(props) {
    const { title, subtitle, btnText, onClick, children } = props;
    const notificationWrapperVariant = useLocalVariant("layout", {
        root: {
            position: "relative",
            height: "420px",
            borderRadius: "12px",
            backgroundColor: "rgba(36, 36, 36, 0.5);",
        }
    });
    const notificationVariant = useLocalVariant("layout", {
        root: {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
        }
    });
    const titleVariant = useLocalVariant("text", {
        root: {
            marginTop: "$s3",
            marginBottom: "$s1",
            fontFamily: "Saira Condensed, Open Sans, sans-serif",
            fontWeight: "700",
            fontSize: "22px",
            lineHeight: "30px",
            textAlign: "center",
            textTransform: "uppercase",
        }
    });
    const subtitleVariant = useLocalVariant("text", {
        $extendFromVariant: "bodySmall",
        root: {
            marginTop: "$s1",
            marginBottom: "$s4",
            textAlign: "center",
        }
    });
    return React.createElement(Layout, { variant: notificationWrapperVariant },
        React.createElement(Layout, { variant: notificationVariant },
            children,
            React.createElement(Text, { testId: "notification-title", variant: titleVariant }, title),
            React.createElement(Text, { testId: "notification-subtitle", variant: subtitleVariant }, subtitle),
            React.createElement(Flex, { justifyContent: "center", alignItems: "center" },
                React.createElement(Button, { testId: "notification-button", variant: "primarySmall", onClick: onClick }, btnText))));
});
//# sourceMappingURL=Notification.js.map